import { render, staticRenderFns } from "./OrderNotificationSnackbar.vue?vue&type=template&id=7fc40c78"
import script from "./OrderNotificationSnackbar.vue?vue&type=script&lang=js"
export * from "./OrderNotificationSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports